import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { blogPosts } from "../data/blogData";
import "../styles/Diary.css";
import ShareButtons from "../components/ShareButtons";
import { Helmet } from "react-helmet";
import AdSenseBlock from "../components/AdSenseBlock";
import { AD_SLOTS } from "../constants/adSlots";

export default function BlogArticle() {
  const { id } = useParams();
  const post = blogPosts.find((p) => p.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatDate = (raw) =>
    new Date(raw).toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  if (!post)
    return <div className="diary-container">記事が見つかりません。</div>;

  // ▼ 構造化データ（BlogPosting）
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    datePublished: new Date(post.date).toISOString(),
    dateModified: new Date(post.date).toISOString(),
    author: {
      "@type": "Person",
      name: "Trail Run Simulator 開発者",
      url: "https://trailrunsim.com/about",
    },
    publisher: {
      "@type": "Organization",
      name: "Trail Run Simulator",
      logo: {
        "@type": "ImageObject",
        url: "https://trailrunsim.com/images/logo.png",
      },
    },
    description: post.summary,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://trailrunsim.com/blog/${post.id}`,
    },
    ...(post.image && {
      image: `https://trailrunsim.com${post.image}`,
    }),
    ...(post.category && {
      articleSection: post.category,
    }),
  };

  return (
    <div className="diary-container" style={{ maxWidth: "820px", margin: "0 auto" }}>
      <Helmet>
        <title>{post.title} | 中の人のトレラン記録</title>
        <meta name="description" content={post.summary} />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* ------------------------------ */}
      {/* 🍏 タイトル・日付（Apple風） */}
      {/* ------------------------------ */}
      <h1
  style={{
    marginBottom: "0.8rem",
    fontSize: "28px",
    fontWeight: 600,
    color: "#1c1c1e",
    lineHeight: 1.3
  }}
>
  {post.title}
</h1>
<p
  className="diary-date"
  style={{
    marginBottom: "1.4rem",
    color: "#6e6e73",
    fontSize: "15px"
  }}
>
  {formatDate(post.date)}
</p>

      {/* ------------------------------ */}
      {/* 🍏 メイン画像（あれば表示） */}
      {/* ------------------------------ */}
      {post.image && (
<img
  src={`https://trailrunsim.com${post.image}`}
  alt={post.title}
  className="diary-image"
  style={{
    borderRadius: "14px",
    marginBottom: "1.8rem",
    width: "100%",
    objectFit: "cover",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
  }}
/>
      )}

      {/* ------------------------------ */}
      {/* 🍏 記事本文（HTML） */}
      {/* ------------------------------ */}
<div
  style={{
    lineHeight: 1.75,
    color: "#1c1c1e",
    fontSize: "17px",
    marginBottom: "2.4rem"
  }}
  dangerouslySetInnerHTML={{ __html: post.content }}
/>

      {/* ------------------------------ */}
      {/* 🍏 シェアボタン */}
      {/* ------------------------------ */}
      <ShareButtons title={post.title} />

      {/* ------------------------------ */}
      {/* 🍏 広告 */}
      {/* ------------------------------ */}
      <div style={{ margin: "2rem 0" }}>
        <AdSenseBlock adSlot={AD_SLOTS.BLOG} />
      </div>

      {/* ------------------------------ */}
      {/* 🍏 戻るリンク（Apple風） */}
      {/* ------------------------------ */}
<p style={{ marginTop: "2.4rem" }}>
  <Link
    to="/blog"
    style={{
      color: "#007aff",
      fontWeight: 500,
      fontSize: "16px",
      paddingLeft: "2px"
    }}
  >
    ← トレラン記録の一覧へ戻る
  </Link>
</p>
    </div>
  );
}
